import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "icon-partner-cbre",
  template: `
    <svg
      version="1.2"
      viewBox="0 0 4304 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="fill-current"
        id="Layer"
        d="m2128.8 727.6c0 145-110.4 292.2-409.3 292.2h-552.2v-1017.3h554.3c296.4 0 396.2 116.7 396.2 253.3 0 88.8-23.7 197-160.3 240.1 0 0 170.8 56.3 171.3 231.7zm-695.1-335.3l370.4 0.1c43.1-4.7 75.6-43.2 75.6-84.6 0-41.4-32.5-76.1-73.5-82.5h-376.7zm438.8 305.3c0-43.5-34.2-80.3-79.9-84.6h-363.6v170.9h355.2c49.8 0 88.7-38.9 88.3-86.3zm1496.3-693h935.2v220.7h-675.2v164.5h608.4v222.8h-608.4v177.6h675.2v233.8h-935.2zm-160.3 268.9c0 179.3-158.1 224.9-158.1 224.9 0 0 153.9 45.7 153.9 197v329h-255.4v-266.4c0-79.9-62.5-142.9-145-145h-285.8v411.4h-259.6v-1019.8h564.9c186 0 383 45.2 385.1 268.9zm-242.2 25.4c-6.8-41.1-41.5-71.5-84.6-71.5h-365.7v162.4h365.7c45.7 0 80.3-36.8 84.6-69.4zm-1959.7 478.2v244.8h-328.9l-86.7-2.1c-160.2-8.5-238-34.7-290-56.2-151.4-69-257.5-196.6-290-350.5-6.4-32.6-8.5-67.3-8.5-101.9 0-110.4 36.8-214.4 104-303.2 54.1-69.3 128.1-125.5 208-162.3 86.3-32.6 170.8-38.9 222.8-41h467.6v231.2h-8.4c-4.2 0-409.3-4.2-482.8 4.3-155.6 19.4-255.4 123.4-255.4 264.2 0 112.5 69.3 251.1 264.2 268.5 121 10.5 471.9 4.2 476.1 4.2 0 0 8 0 8 0z"
        fill-rule="evenodd"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPartnerCbreComponent {}
